import React, { createRef, Component } from 'react';
import { setCookie } from '../utils/cookie_utils.js'
import { buildPath, routeFromPath } from '../utils/route_utils.js'
import { trackEvent } from '../utils/analytics.js'
import '../css/Navbar.css';
import NavbarMenu from './NavbarMenu';

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_lang: this.props.lang,
      mobile_flag: false,
      nav_content: [
      {
        "href_link": "%products%",
        "en": "Products",
        "zh": "產品",
        "ja": "製品"
      },
      {
        "href_link": "/core-technology",
        "en": "Core Technology",
        "zh": "核心技術",
        "ja": "コア技術"
      },
      {
        "href_link": "/about/about_us",
        "en": "About Us",
        "zh": "關於我們",
        "ja": "会社について",
      },
      {
        "href_link": "/about/career",
        "en": "Careers",
        "zh": "人才招募",
        "ja": "採用情報",
      },
      ]
    }

    this.menuRef = createRef();

    this.open_nav = this.open_nav.bind(this)
    this.update_lang = this.update_lang.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.handleResize = this.handleResize.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.current_lang) {
      this.setState({ current_lang: nextProps.lang });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.nav_menu_flag && !prevState.nav_menu_flag) {
      document.addEventListener('mousedown', this.handleClickOutside);
    } else if (!this.state.nav_menu_flag && prevState.nav_menu_flag) {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    if (window.innerWidth > 780 && this.state.mobile_flag) {
      this.setState({ mobile_flag: false });
    }
  }

  handleClickOutside(event) {
    if (this.menuRef.current && !this.menuRef.current.contains(event.target)) {
      this.setState({ nav_menu_flag: false });
    }
  };

  navigate(route) {
    window.location.href = buildPath(this.state.current_lang, route);
  }

  update_lang(lang) {
    setCookie("lang", lang, 30);
    const route = routeFromPath(window.location.pathname);
    window.location.href = buildPath(lang, route);
  }

  open_nav() {
    this.setState({
      mobile_flag: !this.state.mobile_flag
    })
  }

  show_nav_menu(link) {
    if (link[0] === "%") {
      this.setState({
        nav_menu_flag: this.state.nav_menu_flag === link.slice(1, -1) ? false : link.slice(1, -1)
      })
    }
    else {
      this.navigate(link)
    }

  }

  render() {
        const lang = this.state.current_lang;
        const ctaText = { zh: "聯絡我們", en: "Contact Us", ja: "お問い合わせ" };
        const menuLabel = this.state.mobile_flag
          ? { zh: "關閉選單", en: "Close menu", ja: "メニューを閉じる" }
          : { zh: "開啟選單", en: "Open menu", ja: "メニューを開く" };

        return (
          <>
            <nav className={"v2_nav_section "+lang} role="navigation" aria-label="Main navigation">
              <a className="v2_nav_logo_link" href={buildPath(lang, '/')} onClick={(e) => { e.preventDefault(); this.navigate('/'); }}><img className="v2_nav_logo" src="/assets/mainpage_nexuni_white.png" alt="Nexuni"/></a>
              <div className="v2_nav_btn_holder">
                {this.state.nav_content.map((item, idx) => {
                  const isMenu = item["href_link"][0] === "%";
                  const target = isMenu ? "/solutions" : item["href_link"];
                  const menuName = isMenu ? item["href_link"].slice(1, -1) : null;
                  return (
                  <a className="v2_nav_btn" key={idx} href={buildPath(lang, target)}
                  {...(isMenu ? { "aria-haspopup": "true", "aria-expanded": this.state.nav_menu_flag === menuName } : {})}
                  onClick={(e) => { e.preventDefault(); this.show_nav_menu(item["href_link"]); }}>{item[lang]}</a>
                  );
                })}
                <div className="v2_nav_lang">
                  <span>&nbsp;[&nbsp;&nbsp;</span>
                  {lang !== "en" ? <button onClick={() => this.update_lang("en")} className="v2_nav_lang_btn">English</button> : <></>}
                  {lang === "ja" ? <span>&nbsp;|&nbsp;</span> : <></>}
                  {lang !== "zh" ? <button onClick={() => this.update_lang("zh")} className="v2_nav_lang_btn">繁體中文</button> : <span>&nbsp;|&nbsp;</span>}
                  {lang === "en" ? <span>&nbsp;|&nbsp;</span> : <></>}
                  {lang !== "ja" ? <button onClick={() => this.update_lang("ja")} className="v2_nav_lang_btn">日本語</button> : <></>}
                  <span>&nbsp;&nbsp;]&nbsp;</span>
                </div>

                <a className="v2_nav_cta_btn btn-primary" href={buildPath(lang, '/contact')} onClick={(e) => { e.preventDefault(); trackEvent('select_contact', { location: 'navbar' }); this.navigate('/contact'); }}>
                  {ctaText[lang]}
                </a>

                <button type="button" className="v2_append_nav_btn" onClick={this.open_nav}
                  aria-expanded={this.state.mobile_flag} aria-controls="v2_mobile_tab" aria-label={menuLabel[lang]}>
                  <span aria-hidden="true">三</span>
                </button>
              </div>
            </nav>

            {this.state.nav_menu_flag ? <div ref={this.menuRef}><NavbarMenu lang={lang} close_nav={() => this.setState({nav_menu_flag: false})} menu_name={this.state.nav_menu_flag} /></div> : <></>}

            {this.state.mobile_flag ?
              <div className={"v2_mobile_tab "+lang} id="v2_mobile_tab">
                {this.state.nav_content.map((item, idx) => {
                  const target = item["href_link"][0] === "%" ? "/solutions" : item["href_link"];
                  return (
                  <a className="v2_mnav_btn" key={idx} href={buildPath(lang, target)}
                  onClick={(e) => { e.preventDefault(); this.show_nav_menu(item["href_link"]); }}>{item[lang]}</a>
                  );
                })}
                <div className="v2_mobile_lang">
                  {lang !== "en" && <button onClick={() => this.update_lang("en")} className="v2_mobile_lang_btn">English</button>}
                  {lang !== "zh" && <button onClick={() => this.update_lang("zh")} className="v2_mobile_lang_btn">繁體中文</button>}
                  {lang !== "ja" && <button onClick={() => this.update_lang("ja")} className="v2_mobile_lang_btn">日本語</button>}
                </div>
              </div> : <></> }

          </>
        )
  }

}


export default Navbar;
